import BaseProxy from "../../base-proxy";
import LocalStore from "../../../utilities/local-store-manager";

/**
 * @class UpdateCompanyUserProxy
 * @description Class used for communicating with user API.
 * @author Gael F.
 * @version 1.0
 * @since December 10, 2018
 */
export default class UpdateUserProxy {
  /**
   * @async
   * @function execute
   * @param {String} userId - Token used for issuing authenticated request.
   * @param {Object} body - payload parameter instance.
   */
  async execute(userId, body) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/users/${userId}`;
    let localStore = new LocalStore();
    let authToken = localStore.getToken();

    return await baseProxy.putAuthenticatedData(endpointUrl, authToken, body);
  }

  /**
   * @async
   * @function execute
   * @param {String} userId - user id to update.
   * @param {Object} body - payload parameter instance.
   * @param {String} authToken - Token used for issuing authenticated request.
   */
  async updateWithAuthToken(userId, body, authToken) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/users/${userId}`;

    return await baseProxy.putAuthenticatedData(endpointUrl, authToken, body);
  }
}
